type NewsUnreadItem = { id: string; isRead?: boolean };

const newsItemId = (item: NewsUnreadItem) => String(item.id).trim();

/** Browser local read ids win over account `isRead` (e.g. read as guest before login). */
export const isNewsUnread = (item: NewsUnreadItem, { readIds }: { readIds: Set<string> }): boolean => {
    const id = newsItemId(item);
    if (!id) return false;
    if (readIds.has(id)) return false;
    if (item.isRead === true) return false;
    return true;
};

export const applyLocalReadState = <T extends NewsUnreadItem>(item: T, readIds: Set<string>): T =>
    readIds.has(newsItemId(item)) ? { ...item, isRead: true } : item;

export const applyLocalReadStateToList = <T extends NewsUnreadItem>(items: T[], readIds: Set<string>): T[] =>
    items.map((item) => applyLocalReadState(item, readIds));
